import { Edit, SimpleForm, TextInput, BooleanInput, required, Toolbar, SaveButton } from 'react-admin';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const CustomToolbar = (props: any) => (
  <Toolbar {...props} sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
  </Toolbar>
);

export const TimeTrackingActivitiesEdit = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          component="button"
          onClick={() => navigate('/timetracking/activities')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            border: '1px solid #ddd',
            borderRadius: 1,
            px: 2,
            py: 1,
            bgcolor: 'background.paper',
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'grey.100',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <ArrowBackIcon fontSize="small" />
          <Typography variant="body2">Back to TimeTracking Activities</Typography>
        </Box>
      </Box>

      <Edit redirect="list">
        <SimpleForm toolbar={<CustomToolbar />}>
          <TextInput source="name" label="Name" validate={required()} fullWidth />
          <BooleanInput source="isActive" label="Active" />
        </SimpleForm>
      </Edit>
    </Box>
  );
};
